import isObject from 'lodash/isObject';

export const isAutoprolongAvailable = (checkServiceData) => {
  // делаем решение на основе ответа API check-service
  return checkServiceData && isObject(checkServiceData.autoProlongInfo) && checkServiceData.autoProlongInfo.isAvailable;
};
